import { useMedia } from 'react-use';
import { useTheme } from 'styled-components';

export const useIsSmallDesktop = () => {
  const theme = useTheme();
  return useMedia(
    `(max-width: ${theme.breakPoints.smallDesktop * theme.percentBaseResponsive}rem)`
  );
};

export const useIsLandscapeTablet = () => {
  const theme = useTheme();
  return useMedia(
    `(max-width: ${theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem)`
  );
};

export const useIsPortraitTablet = () => {
  const theme = useTheme();
  return useMedia(
    `(max-width: ${theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem)`
  );
};
